import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { LandingPaths } from 'Feature/Common/Common/Constant/LandingPaths';
import ILandingMainPageState from 'Feature/Common/Main/Actions/model';
import { setChangeIconColor } from 'Feature/Common/Main/Actions/reducer';
import { Image } from 'Shared/Components/Image/Image';
import { NumberPagesEnum } from 'Shared/Modules/Enums/NumberPagesEnum';
import { IModuleName } from 'Shared/Modules/Models/IModuleName';
import useAppDispatch from 'Shared/Store/dispatch/useAppDispatch';
import { useAppSelector } from 'Shared/Store/useAppSelector';
import { useTranslationText } from 'Shared/Translation';
import { useUserManager } from 'Shared/User/Hooks/useUserManager';

import RenewTokenModal from './RenewTokenModal';

interface LayoutProps extends IModuleName {
  children: React.ReactNode;
}

const Layout: React.FunctionComponent<LayoutProps> = (props) => {
  const [translation] = useTranslationText();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { getUserClaims } = useUserManager();
  const { userCartItemsTotalCount, changeIconColor } = useAppSelector<ILandingMainPageState>(
    (rootState) => rootState.landing.landingMainPage
  );

  const firstRender = async () => {
    await getUserClaims();
  };

  useEffect(() => {
    firstRender();
    if (location.pathname === LandingPaths.Landing.Main) {
      dispatch(setChangeIconColor(NumberPagesEnum.Landing));
    } else if (location.pathname === LandingPaths.Landing.Cart) {
      dispatch(setChangeIconColor(NumberPagesEnum.Cart));
    } else if (location.pathname === LandingPaths.Landing.Menu) {
      dispatch(setChangeIconColor(NumberPagesEnum.Menu));
    } else {
      dispatch(setChangeIconColor(NumberPagesEnum.Pages));
    }
  }, []);

  const handleCart = () => {
    navigate(LandingPaths.Landing.Cart);
    dispatch(setChangeIconColor(NumberPagesEnum.Cart));
  };

  const handleHome = () => {
    navigate(LandingPaths.Landing.Main);
    dispatch(setChangeIconColor(NumberPagesEnum.Landing));
  };

  const handleMenu = () => {
    navigate(LandingPaths.Landing.Menu);
    dispatch(setChangeIconColor(NumberPagesEnum.Menu));
  };

  return (
    <>
      <main className='main'>
        <div className='container-fluid container-lg px-0 h-100 d-flex flex-column'>
          <div className='logo'>
            <img src={`${window.location.origin}/assets/images/logo.svg`} width='40' height='48' alt='wepod' />
          </div>
          <div className='wrapper d-flex flex-column flex-grow-1 mb-6 mb-md-0'>
            <div className='menu fixed-bottom'>
              <div
                id={'home_button'}
                className={`menu-item ${changeIconColor === NumberPagesEnum.Landing ? 'active' : ''}`}
                onClick={handleHome}
              >
                <Image
                  fileName={changeIconColor === NumberPagesEnum.Landing ? 'wepod-home-active.svg' : 'wepod-home.svg'}
                  style={{ width: '24px' }}
                />
                <span className='text-center'>{translation('SAFHE_ASLI_BIMEH')}</span>
              </div>

              <div
                id={'cart_button'}
                className={`menu-item ${changeIconColor === NumberPagesEnum.Cart ? 'active' : ''}`}
                onClick={handleCart}
              >
                <Image
                  fileName={changeIconColor === NumberPagesEnum.Cart ? 'wepod-cart-active.svg' : 'wepod-cart.svg'}
                  style={{ width: '24px' }}
                />
                <span className='mdi' style={{ left: '10px', top: '-16px' }}>
                  <span className='badge'>
                    {userCartItemsTotalCount.data !== 0 ? userCartItemsTotalCount.data : ''}
                  </span>
                </span>
                <span className='text-center'>{translation('CART')}</span>
              </div>

              <div
                id={'menu_button'}
                className={`menu-item ${changeIconColor === NumberPagesEnum.Menu ? 'active' : ''}`}
                onClick={handleMenu}
              >
                <Image
                  fileName={
                    changeIconColor === NumberPagesEnum.Menu ? 'wepod-services-active.svg' : 'wepod-services.svg'
                  }
                  style={{ width: '24px' }}
                />
                <span className='text-center'>{translation('MENU')}</span>
              </div>
            </div>
            {props.children}
          </div>
        </div>
      </main>
      <RenewTokenModal />
    </>
  );
};

export default Layout;
